import { useGeocode } from '@user/components/Formik/AddressFields/hooks/useGeocode'
import { useState } from 'react'
import { useRecentLocations } from '@user/components/HereMap/hooks/useRecentLocations'

export function useData() {
  const [searchText, setSearchText] = useState('')

  const { result, execute } = useGeocode(2000)
  const { recentSearches, addRecentSearch, clearRecentSearches } =
    useRecentLocations()

  return {
    searchText,
    setSearchText,
    result,
    execute,
    recentSearches,
    addRecentSearch,
    clearRecentSearches,
  }
}

export type UseDataReturn = ReturnType<typeof useData>
